export default __webpack_public_path__ + "static/media/amex.6eae9269.svg";